import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { LayoutsService } from "src/app/services/layouts.service";

@Component({
  selector: "app-admin-navbar",
  templateUrl: "./admin-navbar.component.html",
})
export class AdminNavbarComponent implements OnDestroy {
  currentTitle$: string = "Dashboard";
  subscription: Subscription;

  constructor(private layoutService: LayoutsService) {
    // subscribe to home component messages
    this.subscription = this.layoutService.getHeader().subscribe((message) => {
      if (message) {
        this.currentTitle$ = message;
      } else {
        this.currentTitle$ = "Dashboard";
      }
    });
  }

  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    this.subscription.unsubscribe();
  }
}
